// local//
//-----------------------------------------------------------------------------//

// export const BASE_WS_URL = 'ws://192.168.1.4:8081/ws'; // WebSocket base
// export const BASE_API_URL = 'http://192.168.1.4:8081/api'; //REST API base

// export const SUPPORT_BASE_API_URL = 'http://192.168.1.6:8083/api';
// export const SUPPORT_BASE_WS_URL = 'http://192.168.1.6:8083/ws';  

// export const ACOOUNT_BASE_WS_URL = 'ws://192.168.1.7:8080/ws'; // WebSocket base
// export const ACCOUNT_BASE_API_URL = 'http://192.168.1.7:8080/api'; //REST API base

 export const BASE_WS_URL = 'wss://api.mewin.live/ws'; // WebSocket base
 export const  BASE_API_URL = 'https://api.mewin.live/api'; //REST API base

 export const SUPPORT_BASE_WS_URL = 'wss://support.mewin.live/ws'; // WebSocket base
 export const SUPPORT_BASE_API_URL = 'https://api-support.mewin.live/api'; //REST API base

 export const ACOOUNT_BASE_WS_URL = 'wss://accounts.mewin.live/ws'; // WebSocket base
 export const  ACCOUNT_BASE_API_URL = 'https://api-accounts.mewin.live/api'; //REST API base

//-----------------------------------------------------------------------------//


//-----------------------------------------------------------------------------//
// hosted////
// export const BASE_WS_URL = `ws://${window.location.host}/ws`;
// export const BASE_API_URL = "/api";
                                                                                                                                                                                                                                                                                                                                                                                                              
// export const SUPPORT_BASE_WS_URL =
//   `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://help.mewin.io/ws`;
// export const SUPPORT_BASE_API_URL =
//   `${window.location.protocol}//help.mewin.io/api`;
                                                                                        
// export const ACCOUNT_BASE_WS_URL =
//   `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://accounts.mewin.io/ws`;
// export const ACCOUNT_BASE_API_URL =
//   `${window.location.protocol}//accounts.mewin.io/api`;

//--------------------------------------ss---------------------------------------//


   